const CART_UPDATE_EVENT = 'cart:update';

function formatMoney(cents) {
  return new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD',
  }).format(cents / 100);
}

function renderItems(items) {
  if (!items.length) {
    return `<p class="mcd__empty">Your cart is empty.</p>`;
  }

  return items
    .map((item) => {
      const image = item.featured_image?.url
        ? `<img class="mcd__item-image" src="${item.featured_image.url}&width=144" alt="${item.title}" loading="lazy" width="72" height="72">`
        : `<div class="mcd__item-image"></div>`;

      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<span class="mcd__item-variant">${item.variant_title}</span>`
        : '';

      const isPreorder = item.properties && Object.entries(item.properties)
        .some(([k, v]) => k === 'Note' && v === 'Preorder');
      const preorderBadge = isPreorder ? `<span class="mcd__preorder-badge">Preorder</span>` : '';

      return `
        <div class="mcd__item">
          ${image}
          <div class="mcd__item-details">
            <span class="mcd__item-title">${item.product_title}</span>
            ${preorderBadge}
            ${variant}
            <div class="mcd__item-price-row">
              <span class="mcd__item-price">${formatMoney(item.final_line_price)}</span>
              <span class="mcd__item-qty">Qty ${item.quantity}</span>
            </div>
          </div>
        </div>
      `;
    })
    .join('');
}

async function openMiniCart() {
  const dialog = document.getElementById('mini-cart-drawer');
  if (!dialog) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    document.getElementById('mini-cart-items').innerHTML = renderItems(cart.items);
    document.getElementById('mini-cart-total').textContent = formatMoney(cart.total_price);
  } catch {
    document.getElementById('mini-cart-items').innerHTML = `<p class="mcd__empty">Unable to load cart.</p>`;
  }

  if (!dialog.open) dialog.showModal();
}

function init() {
  const dialog = document.getElementById('mini-cart-drawer');
  if (!dialog) return;

  document.getElementById('mini-cart-close')?.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) dialog.close();
  });

  document.addEventListener(CART_UPDATE_EVENT, (e) => {
    if (e.detail?.data?.didError) return;
    if (e.detail?.data?.source !== 'product-form-component') return;
    if (window.location.pathname === '/cart') return;
    openMiniCart();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
